import { Select } from "@/shared/components/common/Select/Select"
import { useDashboardDepartment } from "./useDashboardDepartment"
import css from './DashboardDepartment.module.css'

function SecondaryDashboardDepartment() {
  const { value, setValue, options, loading, error } = useDashboardDepartment()
  
  return (
    <div className={css.departmentSelectWrapper}>
      <Select
        options={options}
        value={value || ''}
        onChange={setValue}
        placeholder="Выберите подразделение"
        loading={loading.departments}
        error={error.departments ? "Ошибка получения подразделений" : undefined}
        loadingText="Получение подразделений..."
        errorText="Ошибка получения данных"
      />
    </div>
  )
}

export default SecondaryDashboardDepartment